import { medicationsApi } from "ducks/medicationsApi";

export default function useMedicationById(id) {
  const { data } = medicationsApi.useGetSingleMedicationsQuery(id, {
    skip: id === undefined,
  });

  return data;
}
